import Typography from 'components/Typography';
import { ReactComponent as CheckIcon } from 'icons/checked.svg';
import { ReactComponent as CloseIcon } from 'icons/close-black.svg';
import T from 'prop-types';
import React from 'react';

import styles from './Alert.module.scss';

const Alert = ({ open, handleClose, title }) => {
  if (!open) return null;

  return (
    <div className={styles.alert}>
      <div className={styles.alertContainer}>
        <div className={styles.iconContainer}>
          <CheckIcon />
        </div>

        <Typography className={styles.title}>{title}</Typography>
      </div>

      <div className={styles.iconButton} onClick={handleClose}>
        <CloseIcon />
      </div>
    </div>
  );
};

Alert.propTypes = {
  title: T.string,
  handleClose: T.func,
  open: T.bool,
};

export default Alert;
